import { Colors, Services } from '@sigma-frontend-libs/commons'

import { components, icons } from '@/utils'

import buttonConfirm from '@/components/button/confirm'
import squircle from '@/components/icon/squircle'
import arrow from '@/components/misc/arrow'

function renderHeaderContent(h, options) {
  const { path, serviceName } = options

  return h(
    'div',
    {
      class: 'faic grid-gap--8'
    },
    [
      h(
        squircle,
        {
          props: {
            icon: icons.settings,
            color: Colors.grey
          }
        }
      ),
      this.getTranslate(`${serviceName}.subtitles.${path}`)
    ]
  )
}
function renderHeader(h, options, expanded) {
  return h(
    'div',
    {
      class: 'default-expansion-panel-header pl-2'
    },
    [
      renderHeaderContent.call(this, h, options),
      h(arrow, { props: { expanded } })
    ]
  )
}

function renderItem(h, options, field) {
  const { path, defaults, serviceName } = options
  const key = [ path, field ].filter(Boolean).join('.')
  const defaultValue = defaults?.[key]

  return h(
    buttonConfirm,
    {
      props: {
        value: this.proxy[field],
        loading: this.getLoading(field),
        disabled: this.getDisabled(field)
      },
      on: {
        input: () => {
          const value = this.proxy[field] ?? defaultValue

          this.submitField(field, value)
          this.$emit('input', value, key)
        }
      }
    },
    [
      h(
        components.select,
        {
          props: {
            value: this.proxy[field],
            label: this.getTranslate(`${serviceName}.labels.${key}`),
            service: Services.contactLists,
            dense: true,
            clearable: true,
            autocomplete: true,
            details: false
          },
          on: {
            input: event => {
              this.proxy[field] = event
            }
          }
        }
      )
    ]
  )
}
function renderItems(h, options) {
  return this.fields.map(item => {
    return renderItem.call(this, h, options, item)
  })
}
function renderBody(h, options) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8 pa-2'
    },
    [ renderItems.call(this, h, options) ]
  )
}

export default function(h, options) {
  return h(
    components['expansion-panel'],
    {
      props: {
        outline: true,
        rounded: true
      },
      scopedSlots: {
        header: ({ expanded }) => {
          return renderHeader.call(this, h, options, expanded)
        },
        default: () => {
          return renderBody.call(this, h, options)
        }
      }
    }
  )
}
